(function () {
  'use strict';

  angular.module('app').component('inventoryList', inventoryList());

  function inventoryList() {
    return {
      bindings: {},
      controller: InventoryListComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/inventory/inventory-list/inventory-list.component.html',
    };
  }

  InventoryListComponent.$inject = [
    'UtilService',
    '$location',
    'moment',
    '$timeout',
    'InventoryService',
    'TourService',
    'TransportationService',
    'HotelService',
    'ProviderService',
  ];

  function InventoryListComponent(
    UtilService,
    $location,
    moment,
    $timeout,
    InventoryService,
    TourService,
    TransportationService,
    HotelService,
    ProviderService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.search = {
      products: [],
    };

    vm.currentMonth = moment(); // Thu Feb 21 2019 17:23:12 GMT-0600
    vm.currentMonthFormat = vm.currentMonth.format('MMMM, YYYY'); // February, 2019

    vm.monthSelected = moment(); // Thu Feb 21 2019 17:23:12 GMT-0600
    vm.monthSelectedFormat = vm.monthSelected.format('MMMM, YYYY'); // February, 2019

    // private properties
    // -----------------------
    let startDate = moment().utc().startOf('month');
    let endDate = moment().utc().endOf('month');

    // startDate = moment().startOf('month');                       // Fri Feb 01 2019 00:00:00 GMT-0600
    // endDate   = moment().startOf('month').add(1, 'month');       // Fri Mar 01 2019 00:00:00 GMT-0600

    vm.$onInit = function () {
      vm.selectProductType('tour');
    };

    // public methods
    // -----------------------
    vm.selectProductType = function (productType) {
      if (vm.productTypeSelected === productType) return;

      vm.productTypeSelected = productType;

      vm.productSelected = null;
      vm.search.product_id = null;
      vm.inventory = null;

      getProductsByProducType();
    };

    vm.selectProduct = function (product) {
      if (vm.productSelected && vm.productSelected.id === product.id) {
        return;
      }

      vm.productSelected = product;

      vm.associatedProviders = ProviderService.setAssociatedProviders(
        vm.productSelected.associated_providers,
        true
      );

      if (vm.associatedProviders.length > 0) {
        getInventory('');
      }
    };

    vm.goToOtherProduct = function (otherProductId) {
      vm.loadingOtherProduct = true;
      // $timeout(function() { // To avoid multiple clicks on navigation buttons
      let product = vm.UtilService.findItemInArray(vm.products, 'id', otherProductId);
      vm.search.product_id = product.id;

      vm.selectProduct(product);

      vm.loadingOtherProduct = false;
      // }, 500);
    };

    vm.addAssociatedProvidersToProduct = function (product) {
      $location.path(`/${product.type}/${product.id}`).search({ activeTab: 1 });
    };

    vm.onInventorySaved = function (selectedItem) {
      getInventory(selectedItem);
    };

    // This is evaluated when vm.calendarPicker is fired, as change method in component
    vm.changeYearMonth = function (newValue, oldValue) {
      vm.monthSelected = vm.calendarPicker;
      vm.monthSelectedFormat = vm.monthSelected.format('MMMM, YYYY');

      startDate = moment(vm.monthSelected).utc().startOf('month');
      endDate = moment(vm.monthSelected).utc().endOf('month');

      getInventory('');
    };

    vm.goThisMonth = function () {
      vm.calendarPicker = moment(); // Update moment-picker - This evaluates changeYearMonth()
    };

    vm.goPreviousMonth = function () {
      updateNextPrevious(-1, 'month');
    };

    vm.goNextMonth = function () {
      updateNextPrevious(1, 'month');
    };

    vm.reloadInventory = function () {
      getInventory('');
    };

    // private methods
    // -----------------------
    function getProductsByProducType() {
      var labelNotAvailableProducts;

      switch (vm.productTypeSelected) {
        case 'tour':
          vm.labelSelectProduct = 'SELECT_TOUR';
          labelNotAvailableProducts = 'NOT_AVAILABLE_TOURS';

          vm.addProductRoute = 'tour_new';

          vm.applyPickupCosts = true;

          getTours();
          break;
        case 'transportation':
          vm.labelSelectProduct = 'SELECT_TRANSPORTATION';
          labelNotAvailableProducts = 'NOT_AVAILABLE_TRANSPORTATION';

          vm.addProductRoute = 'transportation_new';

          vm.applyPickupCosts = true;

          getTransportations();
          break;
        case 'hotel':
          vm.labelSelectProduct = 'SELECT_HOTEL';
          labelNotAvailableProducts = 'NOT_AVAILABLE_HOTELS';

          vm.addProductRoute = 'hotel_new';

          vm.applyPickupCosts = false;

          getHotels();
          break;
        /*case 'package':
                    vm.labelSelectProduct     = 'SELECT_PACKAGE';
                    labelNotAvailableProducts = 'NOT_AVAILABLE_PACKAGES';

                    vm.addProductRoute = 'package_new';

                    vm.applyPickupCosts = false;

                    getPackages();
                break;*/
      }

      vm.labelNotAvailableProducts = labelNotAvailableProducts;
    }

    function getTours() {
      vm.loadingProducts = true;

      if (vm.tours) {
        $timeout(function () {
          // Hack
          vm.products = vm.tours;

          vm.loadingProducts = false;
        }, 50);

        return;
      }

      var params = {
        get: 'active',
        search: true,
        providers: true,
      };

      TourService.getTours(params).then(function (data) {
        vm.tours = [];

        data.items.forEach(function (item, index) {
          var product = {
            type: 'tour',
            id: item.id,
            name: item.name,
            code: item.code,
            location_id: item.location_id,
            tour_options: item.tour_options,
            associated_providers: item.associated_providers,
            default_provider_id: item.default_provider_id,
            company_id: item.company_id,
            prev: data.items[index - 1],
            next: data.items[index + 1],
          };

          vm.tours.push(product);
        });

        vm.products = vm.tours;
        vm.loadingProducts = false;
      });
    }

    function getTransportations() {
      vm.loadingProducts = true;

      if (vm.transportations) {
        $timeout(function () {
          // Hack
          vm.products = vm.transportations;

          vm.loadingProducts = false;
        }, 50);

        return;
      }

      var params = {
        get: 'active',
        search: true,
        providers: true,
      };

      TransportationService.getTransportations(params).then(function (data) {
        vm.transportations = [];

        data.items.forEach(function (item, index) {
          var product = {
            type: 'transportation',
            id: item.id,
            name: item.name,
            code: item.code,
            departure_location_id: item.departure_location_id,
            arrival_location_id: item.arrival_location_id,
            schedule_type: item.schedule_type,
            transportation_schedules: item.transportation_schedules,
            associated_providers: item.associated_providers,
            default_provider_id: item.default_provider_id,
            company_id: item.company_id,
            prev: data.items[index - 1],
            next: data.items[index + 1],
          };

          vm.transportations.push(product);
        });

        vm.products = vm.transportations;
        vm.loadingProducts = false;
      });
    }

    function getHotels() {
      vm.loadingProducts = true;

      if (vm.hotels) {
        $timeout(function () {
          // Hack
          vm.products = vm.hotels;

          vm.loadingProducts = false;
        }, 50);

        return;
      }

      var params = {
        get: 'active',
        search: true,
        providers: true,
      };

      HotelService.getHotels(params).then(function (data) {
        vm.hotels = [];

        data.items.forEach(function (item, index) {
          var product = {
            type: 'hotel',
            id: item.id,
            name: item.name,
            code: item.code,
            location_id: item.location_id,
            hotel_rooms: item.hotel_rooms,
            associated_providers: item.associated_providers,
            default_provider_id: item.default_provider_id,
            company_id: item.company_id,
            prev: data.items[index - 1],
            next: data.items[index + 1],
          };

          vm.hotels.push(product);
        });

        vm.products = vm.hotels;
        vm.loadingProducts = false;
      });
    }

    function getInventory(selectedItem) {
      const filterCriteria = {
        // startDay:    startDate.format('YYYY-MM-DD'),
        // endDay:      endDate.format('YYYY-MM-DD'),

        startDay: startDate.toISOString(),
        endDay: endDate.toISOString(),
        product_ids: [vm.search.product_id], //getProdutSelectedIds()
      };

      // console.log('getInventory');
      // console.log(vm.search.products);
      // console.log(filterCriteria);
      // return;

      vm.loadingInventory = true;
      InventoryService.getInventory(vm.productTypeSelected, filterCriteria).then(function (data) {
        vm.inventory = data;

        setCalendar();

        if (selectedItem) {
          vm.UtilService.itemListChanged(selectedItem.id);
        }

        vm.loadingInventory = false;
      });
    }

    // Set calendar days, based on the month selected
    function setCalendar() {
      let daysInMonthSelected = vm.monthSelected.daysInMonth();

      let days = [];
      let day;
      for (let i = 1; i <= daysInMonthSelected; i++) {
        day = moment([vm.monthSelected.year(), vm.monthSelected.month(), i]);

        days.push({
          dayNumber: i,
          dayName: day.format('dddd'),
          monthNumber: day.month(),
          monthName: day.format('MMMM'),
          fullDate: day.format('YYYY-MM-DD'),
        });
      }

      vm.calendarDays = days;
    }

    // Add or Less a value for a day, month or week (type)
    function updateNextPrevious(value, type) {
      startDate.add(value, type);
      endDate.add(value, type);

      vm.monthSelected.add(value, type);

      vm.calendarPicker = vm.monthSelected; // Update moment-picker - This evaluates changeYearMonth()
    }

    /*function getProdutSelectedIds() {
            var ids = vm.search.products[0].id;
            for (var i = 1; i < vm.search.products.length; i++) {
                ids += ',' + vm.search.products[i].id;
            }

            return ids;
        }*/
  }
})();

// startDate = moment(vm.monthSelected).startOf('month');
// endDate   = moment(vm.monthSelected).startOf('month').add(1, 'month');
